import { useState } from 'react';

import { useServerClient, configuration as _configuration } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const configuration = _configuration

export const branchTypes = {
    customer: "customer",
    retail: "retailer",
}

export const targetTypes = {
    customer: "customer",
    retail: "retailer",
}

export function useBranches({
    jwtToken: _jwtToken,
    branchType: _branchType,
    targetType: _targetType
}) {

    const [branchType, setBranchType] = useState(_branchType);
    const [targetType, setTargetType] = useState(_targetType);

    const { makeCall, serverClient, getError } = useServerClient(_jwtToken);
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint1 = "user/branch"
    const endpoint2 = "user/branches"

    const list = async (props) => {

        setIsLoading(true);

        // option for configuration
        let configuration = props?.configuration

        try {

            const {
                branchType: overrideBranchType
            } = props;

            let url = getListsUrl(`${endpoint2}/${branchType}`, props);

            if (overrideBranchType) {
                url = getListsUrl(`${endpoint2}/${overrideBranchType}`, props);
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {},
                configuration
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            // setIsLoading(false);
            // throw error;

            if (!serverClient.isCancel(error)) {
                setIsLoading(false);
                throw error;
            } else {
                setIsLoading(true);
            }

        }

        return true;
    }

    const create = async ({ id /* user Id */, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint1}/${id}`;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ userId /* user id */, branchId /* branch Id */, data }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint1}/${userId}/${branchId}`

            const postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            const url = `${endpoint2}/delete`

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = `${endpoint1}/${branchType}/${id}`

            if (dataTypesArray.length) {
                url = getUrlWithDataTypes(`${url}`, dataTypesArray)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        branchTypes,
        targetTypes,
        list,
        get,
        create,
        update,
        remove
    }
}